/**
 * Send the file to the URL. The `ingest` function will be invoked with every
 * incoming line of response from the server (in real-time / streaming mode)
 */
export async function processFileViaStreamingRequest(
  url: string,
  file: File,
  ingest: (line: string) => void,
  formDataFieldName: string = 'file',
) {

  const data = new FormData();
  data.append(formDataFieldName, file as any);

  const response = await fetch(url, {
    method: 'POST',
    body:   data,
  });

  const reader = response!.body!.getReader();

  while (true) {
    const {done, value} = await reader.read();
    if (done) break;
    const str   = String.fromCharCode.apply(null, Array.from(value));
    const lines = str.split("\n").filter(l => !!l.trim());
    for (const line of lines) {
      ingest(line);
    }
  }
}